import React from 'react';

import RespUtils from '../util/RespUtils';
import Dropdown from '../base/Dropdown';

class TokenUtils extends React.Component {
    static renderTokenSwitch(thisObj, token) {
        if (RespUtils.isTabletView()) {
            // return (<React.Fragment>
            //             <br/><div className="tokenList"><Dropdown onSelect={thisObj.onTokenSelect} 
            //                         values={thisObj.state.tokens} defaultValue={token} size="sm" /></div>
            //             <br/>
            //     </React.Fragment>);
            return <div className="tokenList">
                        {TokenUtils.renderRelatedTokens(thisObj)}
                        &nbsp;
                        <Dropdown onSelect={thisObj.onTokenSelect} values={thisObj.state.tokens} 
                            defaultValue={token} size="lg" />
                    </div>
        } else {
            return <div className="tokenList">
                        {TokenUtils.renderRelatedTokens(thisObj)}
                        &nbsp;
                        <Dropdown onSelect={thisObj.onTokenSelect} values={thisObj.state.tokens} 
                            defaultValue={token} size="lg" />
                    </div>
        }
    }

    static renderRelatedTokens(thisObj) {
        if (!thisObj.state.relatedTokens || thisObj.state.relatedTokens.length <= 1) return "";

        return (<Dropdown onSelect={thisObj.onOtherTokenSelect} values={thisObj.state.relatedTokens} 
            customValue="More Networks" size="lg" />);
    }

    static getToken(thisObj, defaultToken) {
        let token = thisObj.state.token;

        if (!token) {
            token = defaultToken;
        }

        if (thisObj.props.match && thisObj.props.match.params.token) {
          token = thisObj.props.match.params.token;
        } 
        
        return token;
    }

    /**
     * get token id from this object
     * if not, get denom from url param
     * if not, get token from url param
     * 
     */

//     static renderTokenSwitch(thisObj, token) {
//     if (RespUtils.isNotTabletView()) {
//         return <div className="tokenList"><Dropdown onSelect={thisObj.onTokenSelect} values={thisObj.state.tokens} 
//             defaultValue={token} size="lg" /></div>
//     }
//   }

//   static renderTokenSwitchResp(thisObj, token) {
//         return <React.Fragment><br/><div className="tokenList"><Dropdown onSelect={thisObj.onTokenSelect} values={thisObj.state.tokens} 
//             defaultValue={token} size="sm" /></div>
//             <br/>
//         </React.Fragment>
//     }
//   }
}

export default TokenUtils;
